import { Injectable } from '@angular/core';

@Injectable()
export class LocalstorageService
{
  private storage: any;

  constructor()
  {
    this.storage = localStorage;
  }

  public retrieveJson(key: string): any
  {
    var item = this.storage.getItem(key);

    if (item !== null && item !== 'undefined') {
      return JSON.parse(this.storage.getItem(key));
    }

    return;
  }

  public storeJson(key: string, value: any)
  {
    this.storage.setItem(key, JSON.stringify(value));
  }

  public retrieve(key: string): any
  {
    var item = this.storage.getItem(key);

    if (item !== null && item !== 'undefined') {
      return this.storage.getItem(key);
    }

    return;
  }

  public store(key: string, value: any)
  {
    this.storage.setItem(key, value);
  }

  public remove(key: string)
  {
    this.storage.removeItem(key);
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/localstorage.service.ts